import type { AsyncProps } from "react-select/async";
import {
	StyledError,
	StyledInputContainer,
	StyledLabel,
} from "../../input-styles";
import { StyledSelect, style } from "../styles";

interface Props extends AsyncProps<any, any, any> {
	id?: string;
	label?: string;
	error?: string;
}

const ReactSelect = ({ id, label, error, ...props }: Props) => {
	return (
		<StyledInputContainer>
			<StyledLabel htmlFor={id}>{label}</StyledLabel>
			<StyledSelect {...props} styles={style} />
			<StyledError>{error}</StyledError>
		</StyledInputContainer>
	);
};

export default ReactSelect;
